import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { btnBlue, btnGhost, card, Field, inp } from "@/components/club/ui";

const ResultRow = ({ e, onSaved }) => {
  const r = e.result || {};
  const [f, setF] = useState({ position: r.position ?? "", faults: r.faults ?? "", time: r.time ?? "", points: r.points ?? "", status: r.status || "ok" });
  const num = (v) => (v === "" ? null : Number(v));
  const save = async () => {
    try { await api.post(`/club/entries/${e.id}/result`, { position: num(f.position), faults: num(f.faults), time: num(f.time), points: num(f.points), status: f.status }); toast.success("Resultado guardado"); onSaved(); } catch (x) { toast.error(errMsg(x)); }
  };
  const box = (k, ph) => <input type="number" step="any" min="0" placeholder={ph} value={f[k]} onChange={(ev) => setF({ ...f, [k]: ev.target.value })} className="w-24 rounded-lg px-2 h-10 text-sm" data-testid={`res-${k}-${e.id}`} />;
  return (
    <li className="py-2 border-b border-slate-100 flex flex-wrap items-center gap-2">
      <span className="flex-1 min-w-[160px] text-sm"><b>{e.order ?? "–"}.</b> {e.rider_name} · {e.horse_name}</span>
      {box("position", "Puesto")}{box("faults", "Faltas")}{box("time", "Tiempo")}{box("points", "Puntos")}
      <select value={f.status} onChange={(ev) => setF({ ...f, status: ev.target.value })} className="rounded-lg px-2 h-10 text-sm" data-testid={`res-status-${e.id}`}>
        {["ok", "eliminado", "retirado", "no presentado"].map((s) => <option key={s} value={s}>{s}</option>)}
      </select>
      <button onClick={save} className="text-sm font-bold text-[#3D88B8]" data-testid={`res-save-${e.id}`}>Guardar</button>
    </li>
  );
};

export const CompStaff = ({ comp, onChange }) => {
  const [s, setS] = useState({ first_time: "09:00", interval_min: 3 });
  const schedule = async () => {
    if (comp.schedule_published && !window.confirm("¿Volver a sortear el orden de salida?")) return;
    try { const { data } = await api.post(`/club/competitions/${comp.id}/schedule`, s); toast.success(`Orden publicado (${data.entries} salidas) y participantes avisados`); onChange(); } catch (e) { toast.error(errMsg(e)); }
  };
  const finish = async () => { await api.post(`/club/competitions/${comp.id}/finish`); toast.success("Concurso finalizado"); onChange(); };
  const exportCsv = async () => {
    const r = await api.get(`/club/competitions/${comp.id}/export`, { responseType: "blob" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(r.data); a.download = `inscritos-${comp.name}.csv`; a.click();
  };
  const confirmed = comp.entries.filter((e) => e.status === "confirmed");
  return (
    <div className={`${card} mt-8 border-[#3D88B8] border-2`} data-testid="comp-staff">
      <h3 className="font-display font-black uppercase text-xl text-[#3D88B8]">Gestión del concurso</h3>
      <div className="flex flex-wrap items-end gap-3 mt-4">
        <Field label="Primera salida"><input type="time" value={s.first_time} onChange={(e) => setS({ ...s, first_time: e.target.value })} className={inp} data-testid="sched-first" /></Field>
        <Field label="Minutos entre salidas"><input type="number" min="1" value={s.interval_min} onChange={(e) => setS({ ...s, interval_min: Number(e.target.value) })} className={inp} data-testid="sched-interval" /></Field>
        <button onClick={schedule} className={btnBlue} data-testid="sched-publish">Sortear y publicar orden</button>
        <button onClick={exportCsv} className={btnGhost} data-testid="comp-export">Exportar a Excel</button>
        {comp.status !== "finished" && <button onClick={finish} className={btnGhost} data-testid="comp-finish">Finalizar concurso</button>}
      </div>
      <p className="mt-6 font-bold">Resultados ({confirmed.length} participantes)</p>
      {comp.categories.map((cat) => (
        <div key={cat} className="mt-3"><p className="text-sm font-bold text-[#B23A38]">{cat}</p>
          <ul>{confirmed.filter((e) => e.category === cat).map((e) => <ResultRow key={e.id} e={e} onSaved={onChange} />)}</ul></div>
      ))}
    </div>
  );
};
